import { useDispatch } from 'react-redux';
import { markAsRead } from '../../store/notificationsSlice';
import axiosClient from '../../axios-client';

export default function NotificationItem({ notification }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (notification.read) return;

    axiosClient.patch(`/notifications/${notification.id}/read`)
      .then(() => dispatch(markAsRead(notification.id)))
      .catch(() => {});
  };

  const timeAgo = (isoDate) => {
    const diff = Math.floor((Date.now() - new Date(isoDate)) / 1000);
    if (diff < 60) return 'Hace un momento';
    if (diff < 3600) return `Hace ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `Hace ${Math.floor(diff / 3600)} h`;
    return `Hace ${Math.floor(diff / 86400)} d`;
  };

  return (
    <div
      className={`notification-item ${!notification.read ? 'unread' : ''}`}
      onClick={handleClick}
    >
      <div className="notification-dot" />
      <div className="notification-body">
        <p className="notification-title">{notification.title}</p>
        <p className="notification-message">{notification.message}</p>
        <span className="notification-time">{timeAgo(notification.created_at)}</span>
      </div>
    </div>
  );
}